const TextFragmentComponent = ({ children }) => children;

export default TextFragmentComponent;
